import { useMutation } from "react-query";
import paths from "../paths";
import axiosInstance from "../../Services/axiosConfig";

async function updateCollectionRequest({ id, payload }) {
  try {
    const url = paths.updateCollectionRequest(id);
    const response = await axiosInstance.put(url, payload);

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

const useUpdateCollectionRequest = () => {
  return useMutation({
    mutationFn: updateCollectionRequest,
  });
};

export { useUpdateCollectionRequest };
